import React, { ChangeEventHandler } from 'react'
import './index.css'

interface Props {
  label: string,
  inputType?: 'text' | 'email' | 'textarea'
  onChangeText: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>,
	name?: string
	required?: boolean
	autoComplete?: string
	value?: string
}

const InputField : React.FC<Props> = ({ label, onChangeText, inputType = 'text', name = '', required = false, autoComplete, value = '' }) => {
	const inputId = name || label.toLowerCase().replace(/\s+/g, '-')

	return (
		<div className='input-field-container'>
			<label className='input-field-label' htmlFor={inputId}>{label}</label>
			{
				inputType === 'textarea'
					? <textarea id={inputId} name={name} className='input-field-input' rows={5} onChange={onChangeText} required={required} value={value} />
					: <input id={inputId} name={name} className='input-field-input' type={inputType} onChange={onChangeText} required={required} autoComplete={autoComplete} value={value} />

			}
		</div>
	)
}

export default InputField
